import { Component, OnInit } from "@angular/core";
import { Globals } from "src/app/core/helpers/globals";
import { UntypedFormBuilder, Validators, ReactiveFormsModule } from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import { IamService } from "src/app/core/apis/iam/api/api";
import { NgIf } from "@angular/common";
import { NgxMaskDirective, provideNgxMask } from "ngx-mask";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@Component({
    selector: "app-ordem",
    templateUrl: "./ordem.component.html",
    styleUrls: ["./ordem.component.css"],
    providers: [provideNgxMask()],
    standalone: true,
    imports: [MatButtonModule, MatIconModule, RouterLink, ReactiveFormsModule, MatFormFieldModule, MatInputModule, NgxMaskDirective, NgIf]
})
export class OrdemComponent implements OnInit {
  form;
  tokenIam;

  constructor(
    private router: Router,
    private iamService: IamService,
    private globals: Globals,
    fb: UntypedFormBuilder
  ) {
    this.form = fb.group({
      nroProcesso: ["", [Validators.minLength(20), Validators.maxLength(20)]]
    });
  }

  ngOnInit() {
    this.globals.subtractFromLoading();
    this.tokenIam = sessionStorage.getItem("JWTToken");
    this.iamService.changeAccount(this.tokenIam)
    .subscribe({
      next: response => {
        this.tokenIam = response.body.accessToken;
        sessionStorage.setItem("JWTToken", this.tokenIam);
      },
      error: error => {
        console.error(error)
      }
    });
  }

  get isValidTokenIam(){

    const tokenIam = this.tokenIam = sessionStorage.getItem('JWTToken');

    if (tokenIam) {
      return tokenIam;
    }
    return false;

  }

  get nroProcesso() {
    return this.form.get("nroProcesso");
  }

  buscarPorNroProcesso(form) {
    this.router.navigate(["listar-ordem", form.nroProcesso]);
  }


}
